import React, { Fragment } from 'react'
import moment from 'moment'
import { Col } from 'antd'
import SelectedRefsTable from 'Components/SelectedRefsTable'
import * as _ from 'lodash'

import { agreementPurpose, agreementRedeliveryOrganization, agreementTransportCosts } from 'Common/constants'
import { getAgreementStateLabel, getPurposeStateLabel } from 'Common/utils'
import SummaryItem from 'Components/SummaryItem'

const getStoreNamesFromProposals = (proposals) => {
  let storeNames = [];

  _.forEach(proposals, proposal => {
    storeNames.push(proposal.storeName)
  })

  storeNames = _.uniq(storeNames)

  return storeNames
}

const styles = {
  state: {
    display: 'block',
    color: '#66cc33',
    fontSize: '0.7em',
    textTransform: 'uppercase'
  }
}

const Summary = props => (
  <Fragment>
    <Col span={24} style={{marginBottom: 16}}>
      <h2>
        {!props.data.asProposal && <strong>
          Proposta di accordo quadro n.{props.data.agreementId} "
          {props.data.title}"
        </strong>}
        {props.data.asProposal && <strong>
          Proposta di reso n.{props.data.agreementId} "
          {props.data.title}"
        </strong>}
        <span style={styles.state}>
          {!props.data.asProposal && props.data.agreementState && getAgreementStateLabel(props.data.agreementState)}
          {props.data.asProposal && props.data.agreementState && getPurposeStateLabel(props.data.proposals[0].state)}
        </span>
      </h2>
    </Col>
    <Col span={12}>
      {props.data.destSupplierId === props.data.origSupplierId && <SummaryItem label="Fornitore">{props.data.destSupplier}</SummaryItem>}
      {props.data.destSupplierId !== props.data.origSupplierId && <SummaryItem label="Fornitore partenza">{props.data.origSupplier}</SummaryItem>}
      {props.data.destSupplierId !== props.data.origSupplierId && <SummaryItem label="Fornitore destinazione">{props.data.destSupplier}</SummaryItem>}
      <SummaryItem label="Causale">
        {agreementPurpose[props.data.agreementPurpose]}
      </SummaryItem>
      <SummaryItem label="Validità">
        dal {moment(props.data.validFrom).format('DD-MM-YYYY')} al{' '}
        {moment(props.data.validTo).format('DD-MM-YYYY')}
      </SummaryItem>
      <SummaryItem label="Negozi">
        {props.data.proposals ? props.data.allStores ? 'Tutti i negozi' : getStoreNamesFromProposals(props.data.proposals).join(', ') : ''}
      </SummaryItem>
    </Col>
    <Col span={12}>
      <SummaryItem label="Organizzazione">
        {props.data.trash === true ? 'Reso per distruzione' : agreementRedeliveryOrganization[props.data.redeliveryOrganization]}
      </SummaryItem>
      {props.data.redeliveryOrganization === 'SEND_TO_SUPPLIER' && <SummaryItem label="Costi di trasporto">
        {agreementTransportCosts[props.data.transportCosts]}
      </SummaryItem>}

      <SummaryItem label="Sede logistica di consegna">
        {props.data.supplierNotes || '//'}
      </SummaryItem>
      {props.data.notes && (
        <SummaryItem label="Note">{props.data.notes}</SummaryItem>
      )}

    </Col>
    <Col span={24} style={{marginTop: 16}}>
      <h3>
        <strong>Referenze:</strong>
      </h3>
      <SelectedRefsTable data={props.data} user={props.user}/>
    </Col>
  </Fragment>
)
export default Summary



// WEBPACK FOOTER //
// ./src/components/Summary/index.js